/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BusinessBillingService {
    /**
     * Get business billing info: plan + credit balance
     * @param businessId
     * @returns any
     * @throws ApiError
     */
    public static businessBillingControllerGetBillingV1(
        businessId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/business/{businessId}/billing',
            path: {
                'businessId': businessId,
            },
        });
    }
    /**
     * Get credit transaction history
     * @param businessId
     * @param limit
     * @param offset
     * @returns any
     * @throws ApiError
     */
    public static businessBillingControllerGetTransactionsV1(
        businessId: string,
        limit?: number,
        offset?: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/business/{businessId}/billing/transactions',
            path: {
                'businessId': businessId,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Get credit usage analytics for the trailing window
     * @param businessId
     * @param days
     * @returns any
     * @throws ApiError
     */
    public static businessBillingControllerGetUsageV1(
        businessId: string,
        days?: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/business/{businessId}/billing/usage',
            path: {
                'businessId': businessId,
            },
            query: {
                'days': days,
            },
        });
    }
}
